import * as React from 'react';
import { CaretLeft, CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import Header from './components/Header';
import Lightbox, { ImagesListType } from 'react-spring-lightbox';
import styled from 'styled-components';

type Props = {
    readonly currentImageIndex: number;
    readonly images: ImagesListType;
    readonly isOpen: boolean;
    readonly onClose: () => void;
    readonly setImageIndex: React.Dispatch<React.SetStateAction<number>>;
    readonly testid?: string;
};

const AttachmentLightbox = ({
    currentImageIndex,
    images,
    isOpen,
    onClose,
    setImageIndex,
    testid = 'messengerAttachmentLightBox',
}: Props) => {
    const gotoPrevious = () => {
        const canPrev = currentImageIndex > 0;
        if (canPrev) {
            setImageIndex((state) => state - 1);
        } else {
            setImageIndex(images.length - 1);
        }
    };

    const gotoNext = () => {
        const canNext = currentImageIndex < images.length - 1;
        if (canNext) {
            setImageIndex((state) => state + 1);
        } else {
            setImageIndex(0);
        }
    };

    return (
        <StyledLightbox
            currentIndex={currentImageIndex}
            data-testid={testid}
            images={images}
            isOpen={isOpen}
            onClose={onClose}
            onNext={gotoNext}
            onPrev={gotoPrevious}
            renderHeader={() => (
                <Header
                    currentImageIndex={currentImageIndex}
                    galleryLength={images.length}
                    galleryTitle={`Attachment ${currentImageIndex + 1}`}
                    onClose={onClose}
                />
            )}
            renderNextButton={() => (
                <IconButton
                    className="absolute right-sm z-10 xsMax:hidden"
                    icon={CaretRight}
                    iconStyle="bold"
                    onClick={gotoNext}
                    variant="outlined"
                />
            )}
            renderPrevButton={() => (
                <IconButton
                    className="absolute left-sm z-10 xsMax:hidden"
                    icon={CaretLeft}
                    iconStyle="bold"
                    onClick={gotoPrevious}
                    variant="outlined"
                />
            )}
            singleClickToZoom
        />
    );
};

export default AttachmentLightbox;

const StyledLightbox = styled(Lightbox)`
    background: ${({ theme }) => theme.colors.white};
    img {
        cursor: zoom-in;
    }
`;
